import {UserDoc, UserDocSchema} from "@repo/shared";

import {deterministicPlayerName} from "~/util/playerNameUtils";

import {BaseCollectionConfig} from "../BaseCollectionConfig";
import {collectionNameV1} from "../collectionName";
import {getByIdHookFactory} from "../factories/getByIdHookFactory";
import {getByIdRealtimeSubFactory} from "../factories/getByIdRealtimeSubFactory";
import {lazyCallbackFactory} from "../factories/lazyCallbackFactory";
import {mutationHookFactory} from "../factories/mutationHookFactory";

export class UserCollectionConfig extends BaseCollectionConfig<
  typeof UserDocSchema,
  unknown
> {
  constructor() {
    super(UserDocSchema);
  }

  getCollection(): [string, ...(string | undefined)[]] {
    return [collectionNameV1("users")];
  }

  parser(id: string, data: unknown): UserDoc {
    if (data === undefined)
      return {
        id: id,
        name: deterministicPlayerName(id),
        color: "#ff0000",
      };
    const parsed = UserDocSchema.partial().parse(data);
    return {
      id,
      name: parsed?.name ?? deterministicPlayerName(id),
      color: parsed?.color ?? "red",
    };
  }
}

const config = new UserCollectionConfig();
export const useUser = getByIdHookFactory(config);
export const useUserRealtimeSub = getByIdRealtimeSubFactory(config);
export const useUpdateUser = mutationHookFactory(config);
export const useLazyCallbackUser = lazyCallbackFactory(config);
